export enum RBACRoleType {
  NoAccess,
  AllAccess = 'CRUD',
  HasAccess = 'CRUD',
  Read = 'R',
  ReadCreate = 'RC',
  ReadUpdate = 'RU',
  ReadUpdateDelete = 'RUD',
  CreateReadUpdate = 'CRU',
}
